var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lottie-player',{staticStyle:{"width":"172px","height":"138px"},attrs:{"src":"/static/message.json","background":"transparent","speed":"1","autoplay":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }